<div class="callout callout-{{calloutStyle}}" [ngClass]="{'clickable': clickable}" role="alert">
    <h3 class="callout-heading" *ngIf="title">
        <i class="fa {{icon}}" *ngIf="icon" aria-hidden="true"></i>
        {{title}}
    </h3>
    <ng-content></ng-content>
</div>
